import React from 'react';
import HTTPStatus from 'http-status';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LinkButtonComponent from '../../button/LinkButtonComponent';

import './ErrorPage.scss';

export class ErrorPage extends React.Component {
    render() {
        const { i18n } = this.props;

        const searchParams = new URLSearchParams(this.props.location.search);
        const errorCode = searchParams.get('code');
        const firstDigit = errorCode ? parseInt(errorCode.charAt(0), 10) : 0;

        let Translation;
        if (Number(errorCode) === HTTPStatus.TOO_MANY_REQUESTS) {
            Translation = i18n.ERROR_PAGE.PAGE_429;
        } else if (firstDigit === 5) {
            Translation = i18n.ERROR_PAGE.PAGE_5XX;
        } else {
            Translation = i18n.ERROR_PAGE.DEFAULT;
        }

        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-error">
                <HeadComponent
                    title={Translation.TITLE}
                    description={Translation.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.ERROR_PATH}${
                        errorCode ? `?code=${errorCode}` : ''
                    }`}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: Translation.BREADCRUMB,
                            route: `${PATH.ERROR_PATH}${errorCode ? `?code=${errorCode}` : ''}`
                        }
                    ]}
                />
                <h1>{Translation.TITLE}</h1>

                <div>
                    <p>{Translation.TEXT1}</p>
                    {Translation.TEXT2 && <p>{Translation.TEXT2}</p>}
                    {Translation.TEXT3 && <p>{Translation.TEXT3}</p>}
                </div>

                {errorCode && (
                    <p className="code">
                        {convertHtmlToReactDomWithParams(Translation.CODE, errorCode)}
                    </p>
                )}

                <LinkButtonComponent
                    to={PATH.HOME_PATH}
                    text={Translation.HOME}
                    title={Translation.HOME}
                    color="main"
                />
            </main>
        );
    }
}

ErrorPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page
    };
}

export default withTemplate(connect(mapStateToProps)(ErrorPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/error/ErrorPage.js